import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageMetaConfig {
  [path: string]: {
    title: string;
    favicon: string;
  };
}

const usePageMeta = () => {
  const location = useLocation();
  
  const pageConfig: PageMetaConfig = {
    '/': {
      title: 'Home | PanWor',
      favicon: '/images/home.png'
    },
    '/projects': {
      title: 'Projects | PanWor',
      favicon: '/images/projects.png'
    },
    '404': {
      title: 'Page Not Found | PanWor',
      favicon: '/images/404.png'
    }
  };

  useEffect(() => {
    // Get the configuration for the current path
    const config = pageConfig[location.pathname] || pageConfig['404'];
    
    // Update document title
    document.title = config.title;
    
    // Update favicon
    const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
    if (favicon) {
      favicon.href = config.favicon;
    }
  }, [location.pathname]);
};

export default usePageMeta;